module.exports = __webpack_public_path__ + "assets/point-white.4f810fad.svg";